import { isNil, isNumber } from 'lodash';
import { ErrorMessage, Rule } from '~domain/model/core/validation/rule';
import { BaseValidator } from '~domain/validators/core/base-validator';

// Validate number respects the minimum and maximum
export class NumberValidator extends BaseValidator<number> {
  protected rules: Rule<number>[];
  private errorMessage: string;
  private maxValue: number;
  private minValue: number;

  constructor(minValue: number, maxValue: number, errorMessage?: string, nullErrorMessage?: string) {
    super();

    // Initialize rules
    this.rules = [this.createNullRule(nullErrorMessage), this.isNumber, this.validateRange];

    this.minValue = minValue;
    this.maxValue = maxValue;
    this.errorMessage = errorMessage || 'validation.error.invalidNumber';
  }

  private isNumber(value: number): ErrorMessage {
    if (!isNumber(value)) return this.errorMessage;
  }

  private validateRange(value: number): ErrorMessage {
    if (!isNil(this.minValue) && value < this.minValue) return this.errorMessage;
    if (!isNil(this.maxValue) && value > this.maxValue) return this.errorMessage;
  }
}
